import React from 'react';
import { Link } from 'react-router-dom';
import { OrderCard as OrderCardType } from '../salesRepOrdersTypes';
import { OrderStatusBadge } from '../../shared';
import styles from './OrderCard.module.css';

interface OrderCardProps {
  order: OrderCardType;
}

export const OrderCard: React.FC<OrderCardProps> = ({ order }) => {
  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div>
          <p className={styles.orderId}>{order.orderId}</p>
          <p className={styles.customer}>{order.customer}</p>
          <p className={styles.date}>📅 {order.date}</p>
        </div>
        <OrderStatusBadge status={order.status} />
      </div>

      <div className={styles.metrics}>
        <div className={styles.metric}>
          <p className={styles.metricLabel}>Value</p>
          <p className={styles.metricValue}>{order.value}</p>
        </div>
        <div className={styles.metric}>
          <p className={styles.metricLabel}>Items</p>
          <p className={styles.metricValue}>{order.items}</p>
        </div>
        <div className={styles.metric}>
          <p className={styles.metricLabel}>Margin</p>
          <p className={`${styles.metricValue} ${styles.margin}`}>{order.margin}</p>
        </div>
        <div className={styles.metric}>
          <p className={styles.metricLabel}>Profit</p>
          <p className={`${styles.metricValue} ${styles.profit}`}>{order.profit}</p>
        </div>
      </div>

      <Link to={`/order-details?id=${order.id}`} className={styles.viewLink}>
        View Details &gt;
      </Link>
    </div>
  );
};
